import { render, staticRenderFns } from "./Diagramm.vue?vue&type=template&id=5b2bc4c1&scoped=true&"
import script from "./diagramm.js?vue&type=script&lang=js&"
export * from "./diagramm.js?vue&type=script&lang=js&"
import style0 from "./diagramm.scss?vue&type=style&index=0&id=5b2bc4c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2bc4c1",
  null
  
)

export default component.exports